import { render, staticRenderFns } from "./ForgotPasswordOk.vue?vue&type=template&id=3a987008&"
import script from "./ForgotPasswordOk.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordOk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports